// extracted by mini-css-extract-plugin
export default {"title":"CardMany_title__nU4Uq","content":"CardMany_content__v7vL9","contentText":"CardMany_contentText__aL+0F"};